module.exports = __webpack_public_path__ + "static/media/bathroom-category.79070e99.png";